import React, { useEffect } from 'react'
import System from "../../../../../helper/system";
import Order from "@system/config/order";
import useReduxState from 'src/hooks/useReduxState';
import { useSearchParams } from 'react-router-dom';
import CommonOrderDetail from '../../CommonOrderDetail';
import { useSelector } from 'react-redux';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import store from 'src/storeWire';
import { system_notification } from 'src/store/slice/system';

let c = System.getParams();

//need to remove page
const OrderDetailListingHeader = () => {
    const [searchParams] = useSearchParams();
    const [isReorderable, setIsReOrderable] = useReduxState(false, 'setIsReOrderable')
    const [OrderDetailTabList__Component__Loader, Set_OrderDetailTabList__Component__Loader] = useReduxState(searchParams.get(CommonOrderDetail.param_key_OrderDetailTabList) ? searchParams.get(CommonOrderDetail.param_key_OrderDetailTabList) : CommonOrderDetail.default_component.param_value, CommonOrderDetail.redux_key_OrderDetailTabList);
    const [{ }, { initiatedKernelCall }, { add_cart_in_Bulk }] = useCartStore();
    const [__check] = useAxiosIndicatorCheck();
    let selected_fields = useSelector((state) => state.entities.model_OrderHistory__UI.selected_fields)

    const onReOrderablePart = async () => {
        let url = Order.getOrderDetailTabsListRouteURL({
            order_number: c.order_number,
            __c_OrderDetailTabList: 'LINE_ITEMS',
            orderFilter: 'yes'
        });
        history.pushState('', '', url);
        Set_OrderDetailTabList__Component__Loader("LINE_ITEMS");
        await setIsReOrderable(true)
    }

    const onAlllink = async () => {
        let url = Order.getOrderDetailTabsListRouteURL({
            order_number: c.order_number,
            __c_OrderDetailTabList: 'LINE_ITEMS',
            orderFilter: 'no'
        });
        history.pushState('', '', url);
        Set_OrderDetailTabList__Component__Loader("LINE_ITEMS");
        await setIsReOrderable(false)
    }

    useEffect(() => {
        if (c.orderFilter && c.orderFilter.toLowerCase() === 'yes') {
            setIsReOrderable(true)
        } else {
            setIsReOrderable(false)
        }
    }, []);

    const AddToCart = async () => {
        let selectedProductData = await add_cart_in_Bulk({ ...selected_fields });
        store.dispatch(system_notification({
            name: 'AddedToCartBomPopup',
            data: {
                cartData: selectedProductData.payload
            },
        }));

        __set('CART_API_CALL');
        await initiatedKernelCall()
        __remove('CART_API_CALL');

    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between pt-0 flex-wrap flex-sm-nowrap">
                <div className="font-24 my-0 mb-3 mb-sm-0 font-bold">Orders</div>

                <div className="ms-sm-auto mb-0">
                    <div className="d-flex align-items-center font-12">
                        <b className='me-2'>View: </b>
                        <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0 seprate-by-pipe font-12 lh-normal mt-0">
                            <li className="ms-2"
                                onClick={() => onAlllink()}><a href={void (0)}
                                    className={isReorderable === true ? 'text-blue2' : 'text-black cursor-default'}> All </a></li>
                            <li className="ms-2"
                                onClick={() => onReOrderablePart()}><a href={void (0)}
                                    className={isReorderable === true ? 'text-black cursor-default' : 'text-blue2'}> Reorderable Parts</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            <div className="pcn-line-divider" />
            <div className='tab-right-area'>
                {
                    isReorderable === true && OrderDetailTabList__Component__Loader === 'LINE_ITEMS' &&
                    <button className="bs5 btn btn-primary w170 mb-3 mb-md-0"
                        disabled={selected_fields && Object.entries(selected_fields).length > 0 ? false : true}
                        onClick={(e) => {
                            __check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status ? e.preventDefault() : AddToCart()
                        }}
                    >add to cart <i
                            className="fa fa-cart-plus ms-1" /></button>
                }
            </div>
        </>
    )
}

export default OrderDetailListingHeader